export default {
  fetchError: 'Erreur lors du chargement de la réservation',
  loading: 'Chargement de la réservation...',
  errorTitle: 'Erreur',
  notFound: 'Réservation introuvable',
  reservationDetails: 'Détails de la Réservation',
  resource: 'Ressource',
  reserver: 'Réservé par',
  reservedFrom: 'Réservé du',
  reservedUntil: 'Réservé jusqu\'au',
  duration: 'Durée',
  createdAt: 'Créé le',
  notes: 'Notes',
  days: 'jours',
  hours: 'heures',
};
